import type { VesselId } from "../types/vessel";

export function normalizeVesselId(value: unknown): VesselId | null {
  if (typeof value === "string") {
    const normalized = value.trim();
    return normalized || null;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    return String(value) as VesselId;
  }

  return null;
}

export function parseOptionalVesselId(value: string): VesselId | undefined {
  return normalizeVesselId(value) ?? undefined;
}

export function parseOptionalVesselIdList(value: string): VesselId[] | undefined {
  const normalizedValues = value
    .split(",")
    .map((item) => normalizeVesselId(item))
    .filter((item): item is VesselId => item !== null);

  if (normalizedValues.length === 0) {
    return undefined;
  }

  return Array.from(new Set(normalizedValues));
}
